var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"width":"68","height":"16","viewBox":"0 0 68 16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('circle',{attrs:{"cx":"8","cy":"8","r":"7.5","stroke":"white"}}),_c('circle',{attrs:{"cx":"34","cy":"8","r":"7.5","stroke":"white"}}),_c('circle',{attrs:{"cx":"60","cy":"8","r":"7.5","stroke":"white"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }